export const leaderSteps = [
    // {
    //     'id': 'idiomas',
    //     'title'  : 'WIZARD.LEADER_GO.STEPS.STP1.WIZBT',
    //     'videoBanner': 'idiomas',
    //     'icon' : 'language',
    //     'ruta' : './languages',
    //     'tituloPagina': 'WIZARD.LEADER_GO.STEPS.STP1.TITULO',
    //     'subtiPagina': 'WIZARD.LEADER_GO.STEPS.STP1.SUBTI',
    //     'status' : 1,
    //     visible: true
    // },
    {
        'id': 'emailEdit',
        'title'  : 'WIZARD.LEADER_GO.STEPS.STP3.WIZBT',
        'videoBanner': 'programar',
        'icon' : 'date_range',
        'ruta' : './editTempl',
        'tituloPagina': 'WIZARD.LEADER_GO.STEPS.STP3.TITULO',
        'subtiPagina':'WIZARD.LEADER_GO.STEPS.STP3.SUBTI',
        'status' : 1,
        visible: true
    },
    {
        'id': 'leaderSelect',
        'title'  : 'WIZARD.LEADER_GO.STEPS.STP2.WIZBT',
        'videoBanner': 'colaboradores',
        'icon' : 'people',
        'ruta' : './selectLea',
        'tituloPagina': 'WIZARD.LEADER_GO.STEPS.STP2.TITULO',
        'subtiPagina': 'WIZARD.LEADER_GO.STEPS.STP2.SUBTI',
        'status' : 1,
        visible: true
    },

    // {
    //     id: 'confirmacion',
    //     title  : 'WIZARD.LEADER_GO.STEPS.STP4.WIZBT',
    //     videoBanner: '',
    //     icon : 'build_circle',
    //     ruta : './confir',
    //     tituloPagina: 'WIZARD.LEADER_GO.STEPS.STP4.TITULO',
    //     subtiPagina: 'WIZARD.LEADER_GO.STEPS.STP4.SUBTI',
    //     status : 1,
    //     visible: true
    // },
    // {
    //     'id': 'avance',
    //     'title'  : 'WIZARD.LEADER_GO.STEPS.STP5.WIZBT',
    //     'videoBanner': 'cierre',
    //     'icon' : 'power_settings_new',
    //     'ruta' : './avance',
    //     'tituloPagina': 'WIZARD.LEADER_GO.STEPS.STP5.TITULO',
    //     'subtiPagina': 'WIZARD.LEADER_GO.STEPS.STP5.SUBTI',
    //     'status' : 1,
    //     visible: true
    // }
];
